import { z } from "zod";

export const getRegionListItemFormSchema = () => {
	return z.object({
		name: z.string().nullable().optional(),
		isDeleted: z.boolean().optional(),
	});
};

export type RegionListItemFormSchema = z.infer<
	ReturnType<typeof getRegionListItemFormSchema>
>;
